import React from "react";
import { MdWarning } from "react-icons/md";
import Button from "../common/Button";
import ModalShell from "./ModalShell";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  itemName: string;
  loading?: boolean;
  /** Request error from the owning page; shown above the buttons. */
  error?: string | null;
  confirmButtonText?: string;
  confirmButtonLoadingText?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  loading = false,
  error = null,
  confirmButtonText = "Delete",
  confirmButtonLoadingText = "Deleting...",
}) => {
  if (!isOpen) return null;

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={<MdWarning className="h-6 w-6 text-red-600 dark:text-red-500" />}
      headerVariant="compact"
      size="sm"
      layout="fixed"
      closeDisabled={loading}
      message={error ? { text: error, type: "error" } : null}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={loading}
            loadingLabel={confirmButtonLoadingText}
          >
            {confirmButtonText}
          </Button>
        </>
      }
    >
      {/* Content */}
      <div className="p-6">
        <p className="mb-4 text-gray-600 dark:text-gray-300">{message}</p>
      </div>
    </ModalShell>
  );
};

export default DeleteConfirmationModal;
